(() => {
  const formatMoney = (cents) => {
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'USD';

    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const moneyToCents = (value) => {
    const cleanValue = String(value || '').replace(/[^0-9.]/g, '');
    return cleanValue ? Math.round(Number(cleanValue) * 100) : 0;
  };

    const getPanelBundlePriceCents = (panel) => {
    const bundlePrice = moneyToCents(panel && panel.dataset ? panel.dataset.bundlePrice : '');

    if (panel && panel.dataset && panel.dataset.aurasDiscoveryPanel === 'true' && bundlePrice === 1999) {
      return 4299;
    }

    return bundlePrice;
  };

  const routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  const initSmartBundle = (root) => {
    if (root.dataset.aurasSmartInitialized === 'true') return;
    root.dataset.aurasSmartInitialized = 'true';

    const variantsScript = root.querySelector('[data-auras-smart-variants]');
    let currentProductVariants = [];

    if (variantsScript) {
      try {
        currentProductVariants = JSON.parse(variantsScript.textContent.trim());
      } catch (error) {
        currentProductVariants = [];
      }
    }

    const currentProductVariantIds = new Set(currentProductVariants.map((variant) => Number(variant.id)));

    const getProductVariantInput = () => {
      const inputs = Array.from(document.querySelectorAll('product-info form[action*="/cart/add"] [name="id"], form[action*="/cart/add"] [name="id"]'));
      return inputs.find((input) => currentProductVariantIds.has(Number(input.value))) || inputs[0] || null;
    };

    const getUrlVariantId = () => {
      try {
        return Number(new URLSearchParams(window.location.search).get('variant')) || 0;
      } catch (error) {
        return 0;
      }
    };

    const getCurrentVariant = () => {
      const input = getProductVariantInput();
      const inputVariantId = currentProductVariantIds.has(Number(input && input.value)) ? Number(input.value) : 0;
      const variantId = inputVariantId || getUrlVariantId() || Number(root.dataset.initialVariantId);
      const variant = currentProductVariants.find((item) => Number(item.id) === variantId);

      if (variant) return variant;
      if (variantId) return { id: variantId, title: '', available: true };

      return null;
    };

    const variantMatchesPanel = (panel) => {
      if (panel.dataset.aurasDiscoveryPanel === 'true' && root.dataset.isCarScentProduct !== 'true') {
        return false;
      }

      if (panel.dataset.aurasHomeDrivePanel === 'true' && root.dataset.isSprayProduct === 'true') {
        return true;
      }

      const requiredText = (panel.dataset.showWhenVariantContains || '').trim().toLowerCase();
      if (!requiredText) return true;

      const variant = getCurrentVariant();
      const variantTitle = variant
        ? [
            variant.title,
            variant.option1,
            variant.option2,
            variant.option3,
            variant.name
          ].filter(Boolean).join(' ').toLowerCase()
        : '';
      const requiredTerms = requiredText.split(',').map((term) => term.trim()).filter(Boolean);

      return requiredTerms.some((term) => variantTitle.includes(term));
    };

    const getVisibleSelects = (panel) => {
      return Array.from(panel.querySelectorAll('[data-auras-smart-select]')).filter((select) => {
        return !select.closest('[hidden]');
      });
    };

    const updatePreview = (select) => {
      const wrapper = select.closest('.auras-smart-select');
      const preview = wrapper && wrapper.querySelector('[data-auras-smart-preview]');
      if (!preview) return;

      const option = select.options[select.selectedIndex];
      const image = preview.querySelector('[data-auras-smart-preview-image]');
      const title = preview.querySelector('[data-auras-smart-preview-title]');

      if (!select.value || !option) {
        if (title) title.textContent = preview.dataset.defaultTitle || '';

        if (preview.dataset.defaultImage && image) {
          image.src = preview.dataset.defaultImage;
          image.alt = preview.dataset.defaultTitle || '';
          image.hidden = false;
        } else if (image) {
          image.hidden = true;
          image.removeAttribute('src');
          image.alt = '';
        }

        return;
      }

      const label = option.dataset.title || option.textContent.trim();

      if (title) title.textContent = label;

      if (option.dataset.image && image) {
        image.src = option.dataset.image;
        image.alt = label;
        image.hidden = false;
      } else if (image) {
        image.hidden = true;
        image.removeAttribute('src');
        image.alt = '';
      }
    };

    const getSelectedItems = (panel) => {
      return getVisibleSelects(panel).map((select) => {
        const option = select.options[select.selectedIndex];

        return {
          id: Number(select.value),
          title: option ? option.textContent.trim() : '',
          available: option ? option.dataset.available !== 'false' && !option.disabled : false,
          price: option ? Number(option.dataset.price || 0) : 0,
          slot: select.dataset.aurasSlot || 'Bundle Item'
        };
      });
    };

    const updatePanelPrice = (panel) => {
      const subtotal = panel.querySelector('[data-auras-subtotal]');
      const discountRow = panel.querySelector('[data-auras-discount-row]');
      const discount = panel.querySelector('[data-auras-discount]');
      const total = panel.querySelector('[data-auras-total]');
      const message = panel.querySelector('[data-auras-price-message]');
      if (!subtotal || !total) return;

      const items = getSelectedItems(panel);
      const selectedSubtotal = items.reduce((sum, item) => sum + (item.id ? item.price : 0), 0);
      const hasMissing = items.some((item) => !item.id);
      const target = getPanelBundlePriceCents(panel);
      const discountAmount = Math.max(0, selectedSubtotal - target);

      subtotal.textContent = formatMoney(selectedSubtotal);

      if (hasMissing) {
        if (discountRow) discountRow.hidden = true;
        total.textContent = formatMoney(selectedSubtotal);
        if (message) message.textContent = 'Choose all bundle items to unlock the bundle price.';
        return;
      }

      if (discountRow) discountRow.hidden = discountAmount <= 0;
      if (discount) discount.textContent = `-${formatMoney(discountAmount)}`;
      total.textContent = formatMoney(target);
      if (message) {
        message.textContent = panel.dataset.discountCode
          ? 'Bundle price unlocked. Discount will be applied in cart/checkout.'
          : 'Bundle price unlocked. Create the matching Shopify discount for checkout to match.';
      }
    };

    const updateVisibility = () => {
      let visiblePanelCount = 0;

      root.querySelectorAll('[data-auras-smart-panel]').forEach((panel) => {
        const shouldShow = variantMatchesPanel(panel);
        panel.hidden = !shouldShow;
        panel.style.display = shouldShow ? '' : 'none';
        if (shouldShow) {
          visiblePanelCount += 1;
          updatePanelPrice(panel);
        }
      });

      if (root.dataset.designMode !== 'true') {
        root.hidden = visiblePanelCount === 0;
      }
    };

    const setStatus = (panel, message, isError = false) => {
      const status = panel.querySelector('[data-auras-status]');
      if (!status) return;
      status.textContent = message;
      status.style.color = isError ? '#9f1d1d' : '';
    };

    const getCartRenderer = () => {
      return document.querySelector('cart-drawer')
        || document.querySelector('cart-notification')
        || document.querySelector('cart-drawer-component');
    };

    const getCartSections = (renderer) => {
      if (renderer && typeof renderer.getSectionsToRender === 'function') {
        return renderer.getSectionsToRender().map((section) => section.id);
      }

      return ['cart-drawer', 'cart-icon-bubble', 'cart-notification', 'cart-live-region-text'];
    };

    const openCart = async (data) => {
      const renderer = getCartRenderer();

      if (renderer && typeof renderer.renderContents === 'function' && data && data.sections) {
        renderer.classList.remove('is-empty');
        renderer.renderContents(data);
        if (typeof renderer.open === 'function') renderer.open();
        return true;
      }

      return false;
    };

    const initDiscoverySampler = (sampler) => {
      if (sampler.dataset.aurasSamplerInitialized === 'true') return;
      sampler.dataset.aurasSamplerInitialized = 'true';

      const panel = sampler.closest('[data-auras-smart-panel]');
      const overlay = sampler.querySelector('[data-auras-sampler-overlay]');
      const openButton = sampler.querySelector('[data-auras-open-sampler]');
      const closeButton = sampler.querySelector('[data-auras-close-sampler]');
      const count = sampler.querySelector('[data-auras-sampler-count]');
      const addButton = sampler.querySelector('[data-auras-add-sampler]');
      const finalAddButton = panel && panel.querySelector('[data-auras-add-discovery-bundle]');
      const summary = panel && panel.querySelector('[data-auras-sampler-summary]');
      const summaryText = panel && panel.querySelector('[data-auras-sampler-summary-text]');
      const cards = Array.from(sampler.querySelectorAll('[data-name]'));
      const limit = Number(sampler.dataset.limit || 5);
      const variantId = Number(sampler.dataset.variantId || 0);
      const bundleTitle = sampler.dataset.bundleTitle || 'Discovery Collection';
       const bundlePrice = getPanelBundlePriceCents(panel);
      const discountCode = (sampler.dataset.discountCode || '').trim();
      const selections = {};

      const initSwiper = () => {
        const swiperElement = sampler.querySelector('.auras-discovery-swiper');

        if (!swiperElement || swiperElement.dataset.aurasSwiperReady === 'true' || typeof window.Swiper === 'undefined') {
          return;
        }

        swiperElement.dataset.aurasSwiperReady = 'true';

        new window.Swiper(swiperElement, {
          loop: true,
          speed: 800,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          allowTouchMove: false,
          pagination: {
            el: swiperElement.querySelector('.swiper-pagination'),
            clickable: false
          }
        });
      };

      const totalSelected = () => {
        return Object.values(selections).reduce((sum, value) => sum + value, 0);
      };

      const selectedSummary = () => {
        return Object.keys(selections)
          .filter((name) => selections[name] > 0)
          .map((name) => `${name} x ${selections[name]}`)
          .join(', ');
      };

      const updateSampler = () => {
        const total = totalSelected();
        const isComplete = total === limit;
        const summaryValue = selectedSummary();

        sampler.dataset.aurasSamplerReady = isComplete ? 'true' : 'false';
        sampler.dataset.aurasSamplerSummary = summaryValue;

        if (count) count.textContent = `${total} / ${limit} Selected`;

        if (summary && summaryText) {
          summary.hidden = !isComplete;
          summaryText.textContent = summaryValue;
        }

        cards.forEach((card) => {
          const name = card.dataset.name;
          const qty = selections[name] || 0;
          const qtyElement = card.querySelector('.qty');
          const plus = card.querySelector('.plus');
          const minus = card.querySelector('.minus');

          if (qtyElement) qtyElement.textContent = qty;
          if (plus) plus.disabled = total >= limit;
          if (minus) minus.disabled = qty === 0;

          card.classList.toggle('selected', qty > 0);
        });

        if (!addButton) return;

        addButton.disabled = !isComplete;

        if (isComplete) {
          addButton.textContent = 'Save sampler selections';
        } else if (total === 0) {
          addButton.textContent = `Choose ${limit} Fragrances`;
        } else {
          addButton.textContent = `Choose ${limit - total} More`;
        }
      };

      const openSampler = () => {
        if (!overlay) return;
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
        initSwiper();
      };

      const closeSampler = () => {
        if (!overlay) return;
        overlay.hidden = true;
        document.body.style.overflow = '';
      };

      openButton?.addEventListener('click', openSampler);
      closeButton?.addEventListener('click', closeSampler);

      overlay?.addEventListener('click', (event) => {
        if (event.target === overlay) closeSampler();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && overlay && !overlay.hidden) {
          closeSampler();
        }
      });

      cards.forEach((card) => {
        const name = card.dataset.name;

        card.querySelector('.plus')?.addEventListener('click', () => {
          if (totalSelected() >= limit) return;
          selections[name] = (selections[name] || 0) + 1;
          updateSampler();
        });

        card.querySelector('.minus')?.addEventListener('click', () => {
          if (!selections[name]) return;

          selections[name] -= 1;

          if (selections[name] <= 0) {
            delete selections[name];
          }

          updateSampler();
        });
      });

      addButton?.addEventListener('click', () => {
        if (totalSelected() !== limit) {
          setStatus(panel, `Please choose ${limit} fragrances first.`, true);
          return;
        }

        updateSampler();
        closeSampler();
        setStatus(panel, 'Sampler selections saved. Choose two car scents to finish.');
      });

      finalAddButton?.addEventListener('click', async () => {
        if (!variantId) {
          setStatus(panel, 'Sampler product variant ID is missing.', true);
          return;
        }

        if (totalSelected() !== limit) {
          setStatus(panel, `Please choose ${limit} fragrances first.`, true);
          return;
        }

        const carScentItems = getSelectedItems(panel);

        if (carScentItems.some((item) => !item.id)) {
          setStatus(panel, 'Please choose both car scents before adding this bundle.', true);
          return;
        }

        const unavailable = carScentItems.find((item) => !item.available);

        if (unavailable) {
          setStatus(panel, `${unavailable.title} is sold out. Please choose another item.`, true);
          return;
        }

        const carScentIds = carScentItems.map((item) => item.id);

        if (root.dataset.allowDuplicateCarScents !== 'true' && new Set(carScentIds).size !== carScentIds.length) {
          setStatus(panel, 'Please choose two different car scents.', true);
          return;
        }

        const originalButtonText = finalAddButton.textContent;
        const bundleKey = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const baseProperties = {
          Bundle: bundleTitle,
          'Bundle price': formatMoney(bundlePrice),
          '_auras_bundle_key': bundleKey,
          '_auras_bundle_price_cents': String(bundlePrice),
          '_auras_bundle_discount_code': discountCode,
          '_bundle_key': bundleKey
        };
        const samplerProperties = {
          ...baseProperties,
          'Bundle slot': 'Gift Sampler Set',
          'Selected fragrances': selectedSummary()
        };

        Object.keys(selections).forEach((name) => {
          samplerProperties[name] = `${selections[name]} Bottle(s)`;
        });

        const items = [
          {
            id: variantId,
            quantity: 1,
            properties: samplerProperties
          },
          ...carScentItems.map((item) => ({
            id: item.id,
            quantity: 1,
            properties: {
              ...baseProperties,
              'Bundle slot': item.slot
            }
          }))
        ];

        setStatus(panel, '');
        finalAddButton.disabled = true;
        finalAddButton.textContent = 'Adding Discovery Bundle...';

        try {
          const renderer = getCartRenderer();
          const cartSections = getCartSections(renderer);
          const response = await fetch(`${routesRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items,
              sections: cartSections,
              sections_url: window.location.pathname
            })
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'Could not add sampler.');
          }

          let data = await response.json();

          if (discountCode) {
            const discountResponse = await fetch(`${routesRoot}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                discount: discountCode,
                sections: cartSections,
                sections_url: window.location.pathname
              })
            });

            if (discountResponse.ok) {
              data = await discountResponse.json();
            }
          }

          Object.keys(selections).forEach((name) => delete selections[name]);
          updateSampler();

          const opened = await openCart(data);

          if (opened) {
            setStatus(panel, 'Discovery bundle added to cart.');
          } else {
            setStatus(panel, 'Discovery bundle added to cart. Opening cart...');
            window.location.href = `${routesRoot}cart`;
          }
        } catch (error) {
          setStatus(panel, error.message || 'Could not add discovery bundle. Please try again.', true);
        } finally {
          finalAddButton.disabled = false;
          finalAddButton.textContent = originalButtonText;
          updateSampler();
        }
      });

      initSwiper();
      window.setTimeout(initSwiper, 500);
      updateSampler();
    };

    root.querySelectorAll('[data-auras-smart-select]').forEach((select) => {
      updatePreview(select);
      select.addEventListener('change', () => {
        updatePreview(select);
        const panel = select.closest('[data-auras-smart-panel]');
        if (panel) updatePanelPrice(panel);
      });
    });

    root.querySelectorAll('[data-auras-type-toggle]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const panel = radio.closest('[data-auras-smart-panel]');
        const selectedType = radio.value;

        panel.querySelectorAll('[data-auras-product-group]').forEach((group) => {
          const isActive = group.dataset.aurasProductGroup === selectedType;
          group.hidden = !isActive;
          group.querySelectorAll('select').forEach((select) => {
            select.disabled = !isActive;
            updatePreview(select);
          });
        });

        updatePanelPrice(panel);
      });
    });

    root.querySelectorAll('[data-auras-discovery-sampler]').forEach(initDiscoverySampler);

    root.querySelectorAll('[data-auras-add-smart-bundle]').forEach((button) => {
      button.addEventListener('click', async () => {
        const panel = button.closest('[data-auras-smart-panel]');
        const bundleTitle = panel.dataset.bundleTitle || 'Bundle';
         const bundlePrice = getPanelBundlePriceCents(panel);
        const discountCode = (panel.dataset.discountCode || '').trim();
        const bundleKey = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const originalButtonText = button.textContent;
        const selectedItems = getSelectedItems(panel);

        setStatus(panel, '');

        if (selectedItems.some((item) => !item.id)) {
          setStatus(panel, 'Please choose every item before adding this bundle.', true);
          return;
        }

        const unavailable = selectedItems.find((item) => !item.available);
        if (unavailable) {
          setStatus(panel, `${unavailable.title} is sold out. Please choose another item.`, true);
          return;
        }

        const carScentIds = selectedItems
          .filter((item) => item.slot.toLowerCase().includes('car scent'))
          .map((item) => item.id);

        if (root.dataset.allowDuplicateCarScents !== 'true' && new Set(carScentIds).size !== carScentIds.length) {
          setStatus(panel, 'Please choose two different car scents.', true);
          return;
        }

        const items = selectedItems.map((item) => ({
          id: item.id,
          quantity: 1,
          properties: {
            Bundle: bundleTitle,
            'Bundle slot': item.slot,
            'Bundle price': formatMoney(bundlePrice),
            '_auras_bundle_key': bundleKey,
            '_auras_bundle_price_cents': String(bundlePrice),
            '_auras_bundle_discount_code': discountCode,
            '_bundle_key': bundleKey
          }
        }));

        button.disabled = true;
        button.textContent = 'Adding...';

        try {
          const renderer = getCartRenderer();
          const cartSections = getCartSections(renderer);
          const response = await fetch(`${routesRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items,
              sections: cartSections,
              sections_url: window.location.pathname
            })
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'Could not add bundle.');
          }

          let data = await response.json();

          if (discountCode) {
            const discountResponse = await fetch(`${routesRoot}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                discount: discountCode,
                sections: cartSections,
                sections_url: window.location.pathname
              })
            });

            if (discountResponse.ok) {
              data = await discountResponse.json();
            }
          }

          const opened = await openCart(data);

          if (opened) {
            setStatus(panel, 'Added to cart.');
          } else {
            setStatus(panel, 'Added to cart. Opening cart...');
            window.location.href = `${routesRoot}cart`;
          }
        } catch (error) {
          setStatus(panel, error.message || 'Could not add bundle. Please try again.', true);
        } finally {
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      });
    });

    updateVisibility();
    root.querySelectorAll('[data-auras-smart-panel]').forEach(updatePanelPrice);

    document.addEventListener('change', () => window.setTimeout(updateVisibility, 0));
    document.addEventListener('click', () => window.setTimeout(updateVisibility, 80));
    document.addEventListener('variant:change', updateVisibility);
    document.addEventListener('product:variant-change', updateVisibility);
    document.addEventListener('option-value-selection-change', () => window.setTimeout(updateVisibility, 80));
    window.addEventListener('popstate', updateVisibility);

    const variantInput = getProductVariantInput();
    if (variantInput) {
      new MutationObserver(updateVisibility).observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-auras-smart-bundle]').forEach(initSmartBundle);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
